// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"89981946","136":"1b316484","156":"5e2711ed","163":"a799dcaf","186":"0e73f372","366":"923ba2fc","681":"cf414dfc","774":"57bf266d","787":"3acc225f","887":"2ed91c29"}[chunkId] + ".chunk.js";
};